import { fromJS } from 'immutable';

import {
  LOAD_SOLUTIONS,
  LOAD_SOLUTIONS_SUCCESS,
  LOAD_SOLUTIONS_FAILURE,
  LOAD_SOLUTIONS_COUNT,
  LOAD_SOLUTIONS_COUNT_SUCCESS,
  LOAD_SOLUTIONS_COUNT_FAILURE,
  IMPORT_SOLUTION,
  IMPORT_SOLUTION_SUCCESS,
  IMPORT_SOLUTION_FAILURE,
} from './actions';

const initialState = fromJS({
  counts: {},
  solutions: [],
  loading: false,
  error: null,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SOLUTIONS:
      return state.set('loading', true).set('error', null);
    case LOAD_SOLUTIONS_SUCCESS:
      return state.set('loading', false).set('solutions', action.solutions);
    case LOAD_SOLUTIONS_FAILURE:
      return state.set('loading', false).set('error', action.error);

    case LOAD_SOLUTIONS_COUNT_SUCCESS:
      return state.set('counts', action.counts);
    case LOAD_SOLUTIONS_COUNT_FAILURE:
      return state.set('error', action.error);
    case IMPORT_SOLUTION:
      return state.set('loading', true).set('error', null);
    case IMPORT_SOLUTION_SUCCESS:
      return state.set('loading', false);
    case IMPORT_SOLUTION_FAILURE:
      return state.set('loading', false).set('error', action.error);
    default:
      return state;
  }
};

export default reducer;
